import { cloneElement, type ReactElement } from 'react';
import { Field } from './ui.js';

/** Отметки обязательности относятся только к конструктору, не к другим формам CRM. */
export function ContractField({label,children,required=true}:{label:string;children:ReactElement<any>;required?:boolean}) {
  const value=children.props.value;
  const empty=required && (value==null || String(value).trim()==='' || value==='choose');
  const badEmail=children.props.type==='email' && Boolean(value) && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value));
  const invalid=empty || badEmail;
  return <Field label={`${label}${required?' *':''}`}>
    {cloneElement(children,{required,'aria-required':required,'aria-invalid':invalid || undefined,
      style:{...children.props.style,...(invalid?{borderColor:'#b77823',backgroundColor:'#fffaf0'}:{})}})}
    {invalid && <span className="mt-1 block text-xs text-amber-800">{badEmail?'Проверьте адрес почты':value==='choose'?'Выберите вариант':'Заполните поле'}</span>}
  </Field>;
}
